import { httpClient } from '@/network/clientController'

/** Get credits List of products available for subscrition
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditproducts
*/
export const requestproductsList = payload => {
	return httpClient({
		method: 'GET',
		url: 'credit/products',
		isCancellable: true
	})
}

/** Gets plafonds for a credit product
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetcreditproducts%7Bpid%7Dsubproduct%7Bspid%7Dplafond
*/
export const requestProductPlafond = payload => {
	return httpClient({
		method: 'GET',
		url: `credit/products/${payload.pid}/subproduct/${payload.spid}/plafond`,
        params: payload.params,
		isCancellable: true
	})
}

/** Create a credit account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcreditproducts%7Bpid%7Dsubproduct%7Bspid%7Dacquire
*/
export const createCreditAccount = payload => {
	return httpClient({
		method: 'POST',
		url: `credit/products/${payload.pid}/subproduct/${payload.spid}/acquire`,
		data: payload.data,
		operationTypeId: '25003' /* for mocks handling of tokens */
	})
}

/** Amortize a credit account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcreditaccounts%7BaccountToAmortizeId%7Dsettlement
*/
export const amortizeCreditAccount = payload => {
	return httpClient({
		method: 'POST',
		url: `credit/accounts/${payload.accountToAmortizeId}/settlement`,
		data: payload.data,
		operationTypeId: '25004' /* for mocks handling of tokens */
	})
}

/** Partial Amortization of credit account
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetcreditaccounts%7BaccountToAmortizeId%7DpartialSettlement
*/
export const partialAmortizeCreditAccount = payload => {
	return httpClient({
		method: 'POST',
		url: `credit/accounts/${payload.accountToAmortizeId}/partialSettlement`,
		data: payload.data,
		operationTypeId: '25004' /* for mocks handling of tokens */
	})
}
